import styled from "@emotion/styled";
import { Colors } from "@snapchat/snap-design-system";

export const Icon = styled.img`
    width: 100%;
    height: 100%;
`;

export const Figure = styled.figure`
    overflow: hidden;

    width: 40px;
    height: 40px;
    margin: 0;

    border: 1px solid ${Colors.Black.V50};
    border-radius: 50%;
`;
